import { VariableType } from 'json-to-graphql-query';
import { Resource } from './resource';

/**
 * Resource danych EPUAP
 *
 * @export
 * @class EpuapResource
 * @extends {Resource}
 */
export class EpuapResource extends Resource {
  /**
   * Pobranie danych formularza do wysyłania dokumentu do EPUAP
   *
   * @param {{ documentId: number }} variables
   * @returns {Promise<{ url: string; data: Record<string, any> }>}
   * @memberof EpuapResource
   */
  public getFormData(variables: { documentId: number }): Promise<{ url: string; data: Record<string, any> }> {
    const query = this.prepareOptions({
      query: {
        __variables: { documentId: 'Int!' },
        epuapFormDataGet: {
          __args: { documentId: new VariableType('documentId') },
          url: true,
          data: true
        }
      }
    });
    return this.query({ query, variables }, 'epuapFormDataGet');
  }
}

export const epuapResource = new EpuapResource();
